<template>
  <div class="w-100">
    <div
      class="Fuell-Table--header"
      v-if="!isLoadingExportHistory"
    >
      <div class="Fuell-Table--item"><span
          class="Fuell-Text"
          v-t="{path:'transactions_export_history_table_header_export_date'}"
        ></span></div>
      <div class="Fuell-Table--item"><span
          class="Fuell-Text"
          v-t="{path:'transactions_export_history_table_header_export_type'}"
        ></span></div>
      <div class="Fuell-Table--item"><span
          class="Fuell-Text"
          v-t="{path:'transactions_export_history_table_header_export_status'}"
        ></span></div>
      <div class="Fuell-Table--item"><span
          class="Fuell-Text"
          v-t="{path:'transactions_export_history_table_header_export_download'}"
        ></span></div>

    </div>
    <div class="Fuell-Table">
      <div
        class="Fuell-Table--content"
        ref="table-content"
      >
        <div
          class="Fuell-Table--row"
          v-for="exportItem in exportItems"
          :key="exportItem.id"
        >
          <div class="Fuell-Table--item"><span class="ml-1">{{exportItem.createdAt | formatTheDate('short_date_year_long_time', true)}} </span></div>
          <div class="Fuell-Table--item"><span class="ml-1" v-tooltip="translateType(exportItem)">{{ translateType(exportItem)}} </span></div>
          <div class="Fuell-Table--item"><span :class="transactionStatusClass(exportItem)">{{ translateStatus(exportItem)}}</span></div>
          <div class="Fuell-Table--item"><span
              class=" w-100 link"
              :disabled="isDownloadingMedia"
              @click="downloadExportItem(exportItem)"
              v-t="{path:'ACTION_DOWNLOAD'}"
              v-if="showDownloadLink(exportItem)"
            ></span></div>

        </div>
      </div>

    </div>
    <div class="d-flex justify-content-center w-100">
      <spinner v-if="isLoadingExportHistory" />
      <div
        class="text-center"
        v-if="isDownloadingMedia"
      >
        <spinner />
        <small v-t.preserve="{path: 'transactions_export_history_download_in_progress'}"></small>

      </div>
    </div>
  </div>
</template>

<script>
import transactionsApi from '../../_api'
import { getResourceFromAws } from '@/shared/_api'
import Spinner from '@/components/Commons/Spinner'
import { EXPORT_TRANSACTION_REPORT_EXTENSION } from '@/utils/constants'
import { COMPANIES_WITH_SPECIFIC_FEATURES } from '../../_constants/constants'

export default {
  name: 'TransactionsExportHistory',
  components: { Spinner },
  data () {
    return {
      exportItems: [],
      isLoadingExportHistory: false,
      isDownloadingMedia: false,
      currentPage: 1,
      lastPage: 1
    }
  },
  methods: {
    showDownloadLink (exportItem) {
      return exportItem.status.code === 'COMPLETE'
    },
    paginationHandler () {
      this.$refs['table-content'].onscroll = () => {
        let table = this.$refs['table-content']
        let bottomOfTable = table.scrollHeight - table.scrollTop === table.offsetHeight
        if (bottomOfTable && this.currentPage < this.lastPage) {
          this.nextPage()
        }
      }
    },
    nextPage () {
      this.currentPage++
      this.fetchExportHistory()
    },
    async downloadExportItem (exportItem) {
      if (this.isDownloadingMedia) return
      this.isDownloadingMedia = true
      try {
        // const { data } = await getMediaUrl(exportItem.media.id)
        // const resource = await getUrlResource(data[0])
        const resource = await getResourceFromAws(exportItem.media.id)
        const exportData = URL.createObjectURL(resource.data)
        const downloadLink = document.createElement('a')
        downloadLink.href = exportData
        downloadLink.download = `Export_GG_${this.translateType(exportItem)}_${this.$moment.utc(exportItem.createdAt).format('DD-MM-YYY')}${EXPORT_TRANSACTION_REPORT_EXTENSION}`
        downloadLink.click()
        URL.revokeObjectURL(exportData)
      } catch (error) {
        console.error(error)
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_download_export_history_error' })
      } finally {
        this.isDownloadingMedia = false
      }
    },
    async fetchExportHistory () {
      if (this.isLoadingExportHistory) return
      this.isLoadingExportHistory = true
      try {
        const { data, headers } = await transactionsApi.getExportHistory(this.currentPage)
        if (this.currentPage === 1) {
          this.exportItems = [...data]
        } else {
          this.exportItems.push(...data)
        }
        this.lastPage = Number.parseInt(headers['pagination-last-page'])
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_fetch_export_history_error' })
      } finally {
        this.isLoadingExportHistory = false
      }
    },
    transactionStatusClass (exportItem) {
      if (exportItem.status.code === 'PENDING') {
        return 'text-info'
      }
      if (exportItem.status?.code === 'PROCESSING' || exportItem.status?.code === 'ERROR') {
        return 'text-warning'
      }
      return 'text-success'
    },
    translateType (exportItemType) {
      if (exportItemType && exportItemType.type && exportItemType.downloadType && exportItemType.downloadType.code.includes('_CARDS')) {
        return this.$t(`transactions_export_history_type__${exportItemType.downloadType.code}`, { card: exportItemType.extraData.card_alias || `${exportItemType.extraData.card_user_first_name} ${exportItemType.extraData.card_user_last_name}` })
      } else if (exportItemType && exportItemType.type && exportItemType.downloadType && exportItemType.downloadType.code.includes('BUDGETS')) {
        if (this.isAnyTwentyFourSevenCompany) {
          return this.$t(`transactions_export_history_type__${exportItemType.type.code}_BUDGETS`, { budget: exportItemType.extraData.budget_name })
        } else {
          return this.$t(`transactions_export_history_type__${exportItemType.downloadType.code}`, { budget: exportItemType.extraData.budget_name })
        }
      } else if (exportItemType && exportItemType.type && exportItemType.downloadType && exportItemType.downloadType.code.includes('EXPENSES_')) {
        return this.$t(`transactions_export_history_type__${exportItemType.downloadType.code}`)
      } else if (exportItemType && exportItemType.type) {
        return this.$t(`transactions_export_history_type__${exportItemType.type.code}`)
      }
      return ''
    },
    translateStatus (exportItemStatus) {
      if (exportItemStatus && exportItemStatus.status) {
        return this.$t(`transactions_export_history_status__${exportItemStatus.status.code}`)
      }
      return ''
    }
  },
  computed: {
    isAnyTwentyFourSevenCompany () {
      return false
      // return this.isTwentyfourSeven || this.isTwentyfourSevenCanarian || this.isSmileMedia || this.isTwentyfourSevenPortugal
    },
    isTwentyfourSeven () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTwentyfourSevenCanarian () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN_CANARIAN')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isSmileMedia () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'SMILE_MEDIA')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTwentyfourSevenPortugal () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN_PORTUGAL')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    }

  },
  mounted () {
    this.paginationHandler()
  },
  async created () {
    await this.fetchExportHistory()
  }

}
</script>

<style scoped>
.Fuell-Table--header,
.Fuell-Table--row {
  grid-template-columns: repeat(4, 1fr);
  padding: 0px 5px;
  width: 100%;
}
.link {
  color: var(--blue-action-1-active);
  text-decoration: underline;
  cursor: pointer;
}
.Fuell-Table--content {
  max-height: 300px;
  overflow-y: auto;
}

@media screen and (min-width: 992px) {
  .Fuell-Table--row:hover::before,
  .Fuell-Table--row.active::before {
    left: 1px;
    width: calc(100% - 1px);
  }
}
</style>
